module.exports = __webpack_public_path__ + "img/googleplay.7c944ba4.png";